import type { SVGProps } from 'react';
const SvgIconUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M9.25 13.5A4.75 4.75 0 0 0 14 8.75v-.5A4.75 4.75 0 0 0 9.25 3.5H4.694l.708-.84A.75.75 0 1 0 4.34 1.6L2.22 3.72a.75.75 0 0 0 0 1.061l2.12 2.122a.75.75 0 0 0 1.06-1.06L4.694 5H9.25a3.25 3.25 0 0 1 3.25 3.25v.5A3.25 3.25 0 0 1 9.25 12h-5.5a.75.75 0 0 0 0 1.5z"
    />
  </svg>
);
export default SvgIconUndo;
